import { useEffect, useState } from "react";

/**
 * Lời chúc sinh nhật An Nhiên – chỉ hiện ngày 27/10 (giờ Việt Nam), mỗi tài khoản một lần trên mỗi trình duyệt.
 * Xem trước ngày khác: thêm ?chucmung=1 vào địa chỉ.
 */
const DAY = "10-27";
const vnDate = () => new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10); // YYYY-MM-DD giờ VN

export default function Birthday({ email }: { email: string }) {
  const [open, setOpen] = useState(false);
  const key = `ahg.bday.${vnDate()}.${email}`;
  useEffect(() => {
    const preview = new URLSearchParams(window.location.search).has("chucmung");
    if (!preview && vnDate().slice(5) !== DAY) return;
    let seen = false;
    try { seen = !preview && localStorage.getItem(key) === "1"; } catch { /* trình duyệt chặn lưu */ }
    if (!seen) setOpen(true);
  }, [key]);
  if (!open) return null;
  const close = () => { try { localStorage.setItem(key, "1"); } catch { /* bỏ qua */ } setOpen(false); };
  return (
    <div className="bdayBack" onMouseDown={(e) => e.target === e.currentTarget && close()} role="dialog" aria-modal="true" aria-labelledby="bdayT">
      <div className="bdayConfetti" aria-hidden="true">{Array.from({ length: 36 }, (_, i) => <i key={i} style={{ left: `${(i * 37) % 100}%`, animationDelay: `${(i % 9) * 0.35}s`, animationDuration: `${3.2 + (i % 5) * 0.5}s` }} />)}</div>
      <div className="bdayCard">
        <div className="bdayCake" aria-hidden="true">🎂</div>
        <div className="bdayDate">27 · 10</div>
        <h2 id="bdayT">Happy Birthday<br /><span>An Nhiên</span></h2>
        <p>Chúc mừng sinh nhật An Nhiên! 🎉<br />Hôm nay AHG Hub cũng chính thức đi vào hoạt động.</p>
        <button className="btn primary" autoFocus onClick={close}>Chúc mừng sinh nhật 🎈</button>
      </div>
    </div>
  );
}
